import { onMounted, onUnmounted } from "vue";
import {
  autosaveActiveSlot,
  initializeSaveSlots,
  resetActiveSlot,
  saveActiveSlot,
  saveSlotsState,
  switchSaveSlot,
} from "../game/saveSlots";

export function useSaveSlots() {
  onMounted(() => {
    initializeSaveSlots();
  });

  onUnmounted(() => {
    saveActiveSlot();
  });

  return {
    state: saveSlotsState,
    autosave: autosaveActiveSlot,
    save: saveActiveSlot,
    switch: switchSaveSlot,
    reset: resetActiveSlot,
  };
}
